var $ = require('jquery');

function ajax(option, success, error) {
	var opt = {};
	typeof option === 'string' ? (opt.url = option) : typeof option === 'object' ? opt = option : 'ajax parameter error';
	success && (opt.success = success);
	error && (opt.error = error);
	opt.data = opt.data || {};
	opt.dataType = opt.dataType || 'jsonp';
	$.ajax(opt);
}
var _ajax = $.ajax;
$.ajax = function(opt) {
	opt.dataType = opt.dataType || 'jsonp';
	return _ajax(opt)
}
module.exports = ajax;


//////////////////
// WEBPACK FOOTER
// ./src/common/ajax.js
// module id = 21
// module chunks = 2